import React, {Component} from "react";
import {TouchableOpacity, View, Text, Image, I18nManager, Dimensions, Alert, KeyboardAvoidingView} from "react-native";
import Colors from "../tools/Colors";
import HMTextView from "./HMTextView";
import {moderateScale} from "../tools/Scaling";

import {connect} from "react-redux";
import {Tools} from "../tools/Tools";
import {typeExport} from "../redux/store/type";
import HMIcon from "./HMIcon";
import Lightbox from "./lightbox/src/Lightbox";
import HMAlert from "./HMAlert";
import HMSvgXml from "./svg/HMSvgXml";
import HMSvgUri from "./svg/HMSvgUri";

const {width, height} = Dimensions.get("window");
let container = null;


class HMListItemTitle extends Component {
    constructor(props) {
        super(props);
        container = this;

    }


    onMorePress() {
        HMAlert(
            'Boom',
            'This is an action call!',
            [{text: 'Aw yeah!'}]
        )
    }

    render() {

        const {wrap, styleText, _svgUri, svgXml, backgroundColor, iconName, iconType, styleRoot, styleTitle, backgroundColorTitle, file, text, textStyle, textType, style, type, borderRadius, height, NoShowIconOnpress, onPress, title, title2, image, props, onPressChild, path, video, nameIcon} = this.props;
        return (
            <View
                style={[
                    styleRoot ? {} : {
                        width: '100%',
                    },
                    {
                        paddingHorizontal: moderateScale(6),
                        marginVertical: moderateScale(iconName ? 0 : 2),
                        //  backgroundColor: backgroundColor ? backgroundColor : Colors.white,
                        borderRadius: moderateScale(2),
                        //  marginHorizontal: moderateScale(6)
                    }, styleRoot,]}
                onPress={onPress}
            >
                <View style={{
                    width: '100%',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    backgroundColor: backgroundColor ? backgroundColor : Colors.white,
                }}>

                    <View style={{width: '100%', flexDirection: 'row'}}>

                        <View
                            style={[!wrap ? {
                                width: moderateScale(iconName ? 30 : 120),
                            } : {}, {
                                //  flex: 1,
                                alignSelf: 'stretch',
                                //flexGrow: 1,
                                //    flexWrap: 'wrap',
                                //    height: '100%',
                                padding: moderateScale(iconName ? 0 : 4),
                                marginHorizontal: moderateScale(4),
                                backgroundColor: backgroundColorTitle ? backgroundColorTitle : Colors.blackLight,
                                // height: moderateScale(28),
                                //  width: moderateScale(28),
                                justifyContent: 'center',
                                alignItems: 'center',
                                //  alignSelf: 'center',
                            }]}>

                            {

                                svgXml || _svgUri || iconName ?
                                    (svgXml || _svgUri ?

                                            (
                                                svgXml ?
                                                    <HMSvgXml xml={svgXml} width="100%" height="100"/>
                                                    :
                                                    <HMSvgUri uri={_svgUri} width="100%" height="100%"/>
                                            )
                                            :
                                            <HMIcon
                                                type={iconType}
                                                name={iconName}
                                                style={{
                                                    fontSize: moderateScale(28),
                                                    color: Colors.blackLight,
                                                    textAlign: "center",
                                                    padding: moderateScale(4),

                                                }}/>
                                    )

                                    :
                                    <HMTextView text={text}
                                                type={"bold"}
                                                style={[{

                                                    fontSize: moderateScale(13),
                                                    color: Colors.white,
                                                    //    textAlign: "center"
                                                }, styleText]}/>

                            }

                        </View>
                        {
                            wrap ?
                                null
                                :
                                <View style={{width: moderateScale(iconName ? 0 : 14)}}/>

                        }

                        <View
                            style={{
                                paddingVertical: moderateScale(8),
                                flex: 1, flexDirection: 'row', alignItems: 'center', alignSelf: 'center'
                            }}>

                            {
                                file && title != null ?
                                    (<TouchableOpacity
                                        onPress={onPressChild}
                                        style={{width: typeExport.WIDTH, flexDirection: 'row'}}
                                    >
                                        {
                                            file == 'image' ?
                                                <Lightbox
                                                    renderContent={() => (
                                                        <View style={{
                                                            width: typeExport.WIDTH,
                                                            height: typeExport.HEIGHT
                                                        }}>
                                                            {
                                                                file === 'image' ?
                                                                    <Image
                                                                        style={{flex: 1, resizeMode: 'contain'}}
                                                                        source={{uri: path}}
                                                                    />
                                                                    :
                                                                    null

                                                            }

                                                        </View>
                                                    )}>
                                                    <HMTextView text={Tools.CheckValue(title) != null ? title : ' - '}
                                                                type={"bold"}
                                                                style={[{

                                                                    fontSize: moderateScale(13),
                                                                    color: Colors.colorPrimary,
                                                                    //    textAlign: "center"
                                                                }, styleTitle]}/>
                                                    {/*  <Image
                                                        style={{
                                                            width: "100%",
                                                            height: "100%", resizeMode: 'contain'
                                                        }}
                                                        source={{uri: 'https://poponik.com/wp-content/uploads/2018/09/Black-Rose-00.jpg'}}
                                                    />*/}
                                                </Lightbox>
                                                :
                                                <HMTextView text={Tools.CheckValue(title) != null ? title : ' - '}
                                                            type={"bold"}
                                                            style={[{

                                                                fontSize: moderateScale(13),
                                                                color: Colors.blue,
                                                                //    textAlign: "center"
                                                            }, styleTitle]}
                                                            styleRoot={{
                                                                //  flexDirection: "row",
                                                                flex: 1,
                                                                //  width:'100%',
                                                                //   justifyContent: "flex-end",
                                                                flexWrap: 'wrap',

                                                            }}

                                                />
                                        }
                                    </TouchableOpacity>)
                                    :
                                    (<HMTextView text={Tools.CheckValue(title) != null ? title : ' - '} type={"bold"}
                                                 style={[styleTitle ? styleTitle : {color: Colors.colorDark,}, {

                                                     fontSize: moderateScale(13),

                                                     //    textAlign: "center"
                                                 }]}
                                                 styleRoot={{
                                                     //  flexDirection: "row",
                                                     flex: 1,
                                                     //  width:'100%',
                                                     //   justifyContent: "flex-end",
                                                     flexWrap: 'wrap',

                                                 }}

                                    />)
                            }


                            {
                                title2 ?
                                    <HMTextView text={title2} type={"bold"}
                                                style={{

                                                    fontSize: moderateScale(14),
                                                    color: Colors.gray,
                                                    //textAlign: "center",
                                                    marginHorizontal: moderateScale(4)
                                                }}
                                                styleRoot={{
                                                    //  flexDirection: "row",
                                                    flex: 1,
                                                    //  width:'100%',
                                                    //   justifyContent: "flex-end",
                                                    flexWrap: 'wrap',

                                                }}
                                    />
                                    :
                                    null
                            }
                        </View>


                    </View>
                    {
                        !NoShowIconOnpress ?
                            <View
                                style={{
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: moderateScale(28),
                                    // width:moderateScale(28),
                                    paddingVertical: moderateScale(8)
                                }}>

                                <TouchableOpacity
                                    style={{alignSelf: 'center'}}
                                    onPress={() => {
                                    }}
                                >
                                    <HMIcon name={I18nManager.getConstants().isRTL ? "ios-arrow-back" : 'ios-arrow-forward'}
                                            style={{
                                                fontSize: moderateScale(20),
                                                color: Colors.gray,
                                                textAlign: "center",
                                                padding: moderateScale(4),

                                            }}/>
                                </TouchableOpacity>

                            </View>
                            :
                            null
                    }

                </View>

            </View>
        );
    }


}

const mapStateToProps = state => {
    return {
        data: state.reducerSplashGetAllData,
        token: state.reducerSplashGetAllData.token,
        DataSplashScreen: state.reducerSplashGetAllData,

    };
};
const mapDispatchToProps = dispatch => {
    return {}
};
export default connect(mapStateToProps, mapDispatchToProps)(HMListItemTitle);
